module.exports = __webpack_public_path__ + "img/kyoukai.7e86fe85.png";